import { animate, state, style, transition, trigger } from '@angular/animations';

var inOutAnimation = trigger('inOutAnimation', [
  transition(':enter', [
    style({ transform: 'translateX(100%)', opacity: 0 }),
    animate('.25s ease-out', style({ transform: 'translateX(0%)', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ transform: 'translateX(0%)', opacity: 1 }),
    animate('0.25s ease-in', style({ transform: 'translateX(100%)', opacity: 0 })),
  ]),
]);

var fadeSlideInOut = trigger('fadeSlideInOut', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(10px)' }),
    animate('500ms', style({ opacity: 1, transform: 'translateY(0)' })),
  ]),
  transition(':leave', [animate('500ms', style({ opacity: 0, transform: 'translateY(10px)' }))]),
]);

var fadeSlideInOutResume = trigger('fadeSlideInOutResume', [
  state(
    'offStage',
    style({
      opacity: 0,
      transform: 'translateY(10px)',
    })
  ),
  state(
    'onStage',
    style({
      opacity: 1,
      transform: 'translateY(0px)',
    })
  ),
  transition('offStage => onStage', [animate('500ms')]),
]);

export { inOutAnimation, fadeSlideInOut, fadeSlideInOutResume };
